'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let app = window.app;
class ContactForm extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      loading: false,
      status_messages: {}
    });
    (0, _defineProperty2.default)(this, "handleChange", _handleChange.default.bind(this));
    (0, _defineProperty2.default)(this, "submit", e => {
      const component = this,
        props = this.props,
        state = this.state;
      e === null || e === void 0 ? void 0 : e.preventDefault();
      component.setState({
        loading: true
      });
      const data = (0, _getFormData.default)({
        state: state,
        pattern: 'contact['
      });
      qwest.post((0, _Routing.action)('SubmitContact'), data).then(function (xhr, response) {
        component.setState({
          loading: false,
          'contact[content]': '',
          'contact[email]': '',
          'contact[name]': '',
          info: response.info
        });
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-dark']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "contact-form"
    }, /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: (0, _Routing.action)('SubmitContact'),
      className: "contact-form__content",
      onSubmit: component.submit
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      className: "contact-form__input",
      value: state['contact[name]'],
      name: "contact[name]",
      label: "Nom",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      className: "contact-form__input",
      value: state['contact[email]'],
      name: "contact[email]",
      label: "E-mail",
      type: "email",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      className: "contact-form__input",
      value: state['contact[content]'],
      name: "contact[content]",
      label: "Message",
      rows: "4",
      multiline: true,
      status: state.status_messages
    }), (0, _getFormStatus.default)(state), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "submit",
      className: "c-btn c-btn--full u-margin-top-30"
    }, loader, "Envoyer")));
    return output;
  }
}
exports.default = ContactForm;
